import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { displayValues } from '../../../../../../utils/index';

@Component({
  selector: 'app-detail-dialog',
  templateUrl: './detail-dialog.component.html',
  styleUrls: ['./detail-dialog.component.scss']
})
export class DetailDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    // console.log("data from dialog ", this.data);
  }

  displayValues = displayValues;

  getAddressValue(address, city, state, zip) {
    if ((zip && address && address.toString().includes(zip.toString())) ||
      (city && address && address.toString().includes(city.toString())) ||
      (state && address && address.toString().includes(state.toString()))) {
      return (address ? address.toString() : "");
    }
    else {
      return (address ? address.toString() : "") + (city ? (", " + city.toString()) : "") + (state ? (", " + state.toString()) : "") + (zip ? (", " + zip.toString()) : "");
    }
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/detail-dialog/detail-dialog.component.ts